import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    return (
        <>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1724561155017/high_light_3.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1724561155017/high_light_3.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724569283782/high_light_3_h5.jpg"
            />
            <div className="card-box card-box3 card-box-left">
                <div className="card-title">{t('item3_title')}</div>
                <div className="card-desc">{t('item3_desc')}</div>
            </div>
        </>
    );
}
